(() => {
  const ROTATION_DELAY = 2400;
  // Script defer'li olduğu için ağır sayfalarda geç çalışıyor; ilk geçişi kısa tutunca
  // şerit çalıştığı anda hareket ediyor, ilk kare ekranda takılı kalmıyor.
  const FIRST_DELAY = 1000;
  const DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];

  // Kargo rozeti metni. Aynı kesim kuralı snippets/dorimo-shipping-cutoff.liquid
  // içinde de var (ürün sayfasındaki geri sayım) — biri değişirse diğeri de değişmeli.
  // Türkiye kalıcı UTC+3; getUTC* ile okuyunca İstanbul yerel saati elde edilir.
  function isShippingDay(day, shipSaturday) {
    if (day === 0) return false;
    if (day === 6) return shipSaturday;
    return true;
  }

  function shippingLabel(cutoffHour, shipSaturday) {
    const now = new Date(Date.now() + 3 * 60 * 60 * 1000);
    const day = now.getUTCDay();

    if (isShippingDay(day, shipSaturday) && now.getUTCHours() < cutoffHour) return 'Bugün kargoda';

    let offset = 1;
    let nextDay = (day + 1) % 7;
    while (!isShippingDay(nextDay, shipSaturday) && offset < 8) {
      offset += 1;
      nextDay = (day + offset) % 7;
    }

    return offset === 1 ? 'Yarın kargoda' : DAYS[nextDay] + ' kargoda';
  }

  function applyShippingLabel(status) {
    const target = status.querySelector('[data-card-status-shipping]');
    if (!target) return;

    let cutoffHour = parseInt(status.dataset.cutoffHour, 10);
    if (isNaN(cutoffHour)) cutoffHour = 15;

    target.textContent = shippingLabel(cutoffHour, status.dataset.shipSaturday !== '0');
  }

  function initializeStatus(status) {
    applyShippingLabel(status);

    if (status.dataset.cardStatusReady === 'true') return;

    const items = Array.from(status.querySelectorAll('[data-card-status-item]'));
    status.dataset.cardStatusReady = 'true';
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let index = 0;
    let timer;

    const show = (nextIndex) => {
      items.forEach((item, itemIndex) => {
        const active = itemIndex === nextIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      index = nextIndex;
    };

    const stop = () => window.clearTimeout(timer);
    const queue = (delay) => {
      stop();
      timer = window.setTimeout(() => {
        show((index + 1) % items.length);
        queue(ROTATION_DELAY);
      }, delay);
    };
    const start = () => queue(ROTATION_DELAY);

    status.addEventListener('mouseenter', stop);
    status.addEventListener('mouseleave', start);
    status.addEventListener('focusin', stop);
    status.addEventListener('focusout', start);
    queue(FIRST_DELAY);
  }

  function initializeAll(root = document) {
    root.querySelectorAll('[data-card-status]').forEach(initializeStatus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
